import queryString from "query-string";

const { parse, stringify } = queryString;

// A2: TM filter state lives in the URL (GET params), variant 1 —
// "empty URL = empty filter". These two pure functions are the whole
// contract between the URL and the redux filter object:
//   URL --getFilterByLocationSearch--> filter (on LOCATION_CHANGE)
//   filter --getQueryByFilter--> URL   (on APPLY_FILTER)
// Unlike the timeplan module we deliberately do NOT persist the last
// URL in localStorage — that "filter follows me between tabs" behavior
// is exactly the A2c complaint.

export const FILTER_KEYS = [
  "task_status",
  "search",
  "author_id",
  "assignee_id",
  "task_type_id",
  "subtasks",
];

/**
 * getFilterByLocationSearch
 * Parse a location.search string into a TM filter object.
 * A task deep link (?task_id=N) maps to ONLY {search: "task=N"} so an
 * active status/assignee filter can never hide the linked task (A2a).
 * @param {String} search  location.search ("?a=b" or "a=b")
 * @returns {Object} filter
 */
export const getFilterByLocationSearch = (search) => {
  const params = parse(search || "");

  if (params.task_id) return { search: `task=${params.task_id}` };

  return FILTER_KEYS.reduce((filter, key) => {
    const value = params[key];
    if (value !== undefined && value !== null && `${value}`.length > 0) {
      filter[key] = `${value}`;
    }
    return filter;
  }, {});
};

/**
 * getQueryByFilter
 * Serialize a TM filter object into a stable (alphabetically sorted)
 * query string. Empty values and the default task_status "all" are
 * omitted, so "no filters" is a clean /task-manager URL.
 * @param {Object} filter
 * @returns {String} query string without the leading "?"
 */
export const getQueryByFilter = (filter = {}) => {
  const query = FILTER_KEYS.reduce((acc, key) => {
    const value = filter[key];
    if (value === undefined || value === null || `${value}`.length === 0)
      return acc;
    if (key === "task_status" && value === "all") return acc;
    acc[key] = `${value}`;
    return acc;
  }, {});

  return stringify(query, { sort: (a, b) => a.localeCompare(b) });
};
